<template lang="pug">
  div
    v-btn(
      v-bind="$attrs"
      @click="importData"
      :loading="importPosPosting"
    )
      slot
</template>
<script>
  import saleInventoryRepository from '@/repositories/sale-inventory.repository'
  import stockRepository from '@/repositories/stock.repository'
  import importRepository from '@/repositories/import.repository'
  import VueRequestHandler from '@/classes/VueRequestHandler.class'
  import requestVars from '@/extra-functions/request-vars.extra'
  import fs from 'fs'
  import CryptoJs from 'crypto-js'

  const { dialog } = require('electron').remote

  const [stockVars, stockVarNames] = requestVars({ identifier: 'stock' })
  const [importPosVars, importPosVarNames] = requestVars({ identifier: 'import-pos', request: 'post', hasData: false })

  const stockHandler = new VueRequestHandler(null, stockVarNames)
  const importPosHandler = new VueRequestHandler(null, importPosVarNames)

  export default {
    name: 'ImportFromPos',
    data () {
      return {
        ...stockVars,
        ...importPosVars,
      }
    },
    computed: {
      keyedStocks () {
        return this.stockList.reduce((result, stock) => {
          if (!result[stock.store_id]) {
            result[stock.store_id] = { [stock.stock_code]: [stock?.id, stock?.supplier?.id] }
            return result
          }
          result[stock.store_id][stock.stock_code] = [stock?.id, stock?.supplier?.id]
          return result
        }, {})
      },
    },
    created () {
      // this.getStocks()
    },
    methods: {
      getStocks () {
        const handler = stockHandler
        const repository = stockRepository.withSupplier
        handler.setVue(this)
        handler.execute(repository)
      },
      async importData () {
        if (this.importPosPosting) return
        try {
          const { canceled, filePaths } = await dialog.showOpenDialog({ filters: 'cpos' })
          if (canceled) return
          const [path] = filePaths
          this.$alertSwalLoading()
          const encData = fs.readFileSync(path, { encoding: 'utf8' })
          const bytes = CryptoJs.AES.decrypt(encData, process.env.VUE_APP_POS_ENCRYPTION_KEY)
          const decData = bytes.toString(CryptoJs.enc.Utf8)
          const data = JSON.parse(decData)
          const handler = importPosHandler
          const repository = importRepository.pos
          handler.setVue(this)
          await handler.execute(repository, [data])
          this.$alertSwalSuccess('Successfully imported data from pos!!!')
        } catch (err) {
          this.$alertSwalError(err.message)
        }
      },
      async checkReceipt (sales) {
        try {
          const receipts = Object.keys(sales)
          const { data } = await saleInventoryRepository.filterNewReceipts(receipts)
          return data.reduce((result, key) => {
            result = result.concat(...sales[key])
            return result
          }, [])
        } catch (err) {
          alert(err)
          return []
        }
      },
    },
  }
</script>
